// extracted by mini-css-extract-plugin
export default {"container":"SportsPage_container__7nIoS"};